










import { Component, Vue, Watch } from 'vue-property-decorator';
import { removeToken, removeUserInfo } from '@/utils/utils';
import store from '@/store';

@Component
export default class Home extends Vue {
  public reload: any = '';
  public get currentRouter() {
    return store.state.router;
  }
  public reloadHref(value) {
    this.reload = value;
    setTimeout(() => {
      this.$router.go(0);
    }, 1);
  }
  public get locale(): string {
    return this.$i18n.locale;
  }
  public logout(): void {
    this.$store.commit('reset');
    removeToken();
    removeUserInfo();
    this.$router.push({ name: 'login' });
  }
}
